/* begin general import */

import { ResponsibilityAppUserGroupingMappingsFilter } from "models/ResponsibilityAppUserGroupingMappings";
import React from "react";
import { FilterAction, filterReducer, filterService } from "services/page-services/filter-service";
import { responsibilityRepository } from "repositories/responsibility-repository";
import { listService } from "services/page-services/list-service";
import { tableService } from "services/page-services/table-service";

/* end individual import */

export function useResponsibilityGroupUserModal() {
    const [visibleGroupUser, setVisibleGroupUser] = React.useState(false);
    const [modelFilter, dispatchFilter] = React.useReducer<
        React.Reducer<ResponsibilityAppUserGroupingMappingsFilter, FilterAction<ResponsibilityAppUserGroupingMappingsFilter>>
    >(filterReducer, {
        ...new ResponsibilityAppUserGroupingMappingsFilter(),
    });
    const {
        value: filter,
        handleChangeAllFilter
    } = filterService.useFilter(modelFilter, dispatchFilter);

    const { list, count, loadingList, handleLoadList } = listService.useList(
        responsibilityRepository.listAppUserGrouping,
        responsibilityRepository.countAppUserGrouping,
        modelFilter,
        dispatchFilter
    );

    const { handleTableChange, handlePagination } = tableService.useTable(
        filter,
        handleChangeAllFilter
    );

    const handleOpenModelGroupUser = React.useCallback(() => {
        setVisibleGroupUser(true);
    }, []);

    const handleCloseModelGroupUser = React.useCallback(() => {
        setVisibleGroupUser(false);
    }, []);

    return {
        handleOpenModelGroupUser,
        visibleGroupUser,
        setVisibleGroupUser,
        handleCloseModelGroupUser,
        list,
        count,
        loadingList,
        filter,
        handlePagination,
        handleTableChange,
        modelFilter,
        dispatchFilter,
        handleLoadList
    };
}
